import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from 'react-bootstrap';
import { getTodayInputDate } from '../superadmin/superadminDateUtils';
import { egresoDisplayFromResponse } from '../../../utils/formatEgresoNumero';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';
import { FORMA_PAGO_OPCIONES } from '../../../utils/formasPago';

function CrearEgreso() {
    const history = useHistory();
    const location = useLocation();
    const prefijoLiquidacion = location.state?.fromLiquidacion ? location.state : null;
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [fecha, setFecha] = useState(getTodayInputDate());
    const [usuario, setUsuario] = useState('');
    const [numeroEgreso, setNumeroEgreso] = useState('');
    const [numeroEgresoCreado, setNumeroEgresoCreado] = useState('');
    const [metodoPago, setMetodoPago] = useState('10');
    const [usuarios, setUsuarios] = useState([]);
    const [proveedorId, setProveedorId] = useState('');
    const [nombreProveedor, setNombreProveedor] = useState('');
    const [tipoProveedor, setTipoProveedor] = useState('NIT');
    const [documentoProveedor, setDocumentoProveedor] = useState('');
    const [productos, setProductos] = useState([]);
    const [conceptoSeleccionado, setConceptoSeleccionado] = useState('');
    const [totalBruto, setTotalBruto] = useState(0);
    const [totalPagar, setTotalPagar] = useState(0);
    const [conceptosPago, setConceptosPago] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [showModalProveedor, setShowModalProveedor] = useState(false);
    const [proveedores, setProveedores] = useState([]);
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const [loading, setLoading] = useState(false);
    const proveedoresPorPagina = 10;

    // Estados para modales de confirmación
    const [showModalExito, setShowModalExito] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [mensajeError, setMensajeError] = useState('');
    const [egresoGuardadoId, setEgresoGuardadoId] = useState(null);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Usar el mismo permiso que documento soporte
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'ver_listado_documentos_soporte');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('ver_listado_documentos_soporte')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar usuarios
        axios.get('/usuarios?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setUsuarios(response.data);
            })
            .catch(error => console.log('err: ' + error));

        // Cargar proveedores
        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    const lista = response.data || [];
                    setProveedores(lista);
                    if (prefijoLiquidacion?.proveedorId) {
                        const p = lista.find((x) => String(x.id) === String(prefijoLiquidacion.proveedorId));
                        if (p) {
                            setProveedorId(p.id);
                            setNombreProveedor(p.nombre_proveedor);
                            setTipoProveedor(p.tipo_documento || 'NIT');
                            setDocumentoProveedor(p.numero_documento || '');
                        } else {
                            setProveedorId(prefijoLiquidacion.proveedorId);
                            setNombreProveedor(prefijoLiquidacion.nombreProveedor || '');
                            setTipoProveedor(prefijoLiquidacion.tipoDocumento || 'NIT');
                            setDocumentoProveedor(prefijoLiquidacion.numeroDocumento || '');
                        }
                        if (prefijoLiquidacion.observaciones) {
                            setObservaciones(prefijoLiquidacion.observaciones);
                        }
                    }
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar conceptos de pago
        axios.get('/conceptos-pago?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) setConceptosPago(response.data);
            })
            .catch(error => console.log('err: ' + error));

        // Obtener el próximo número de egreso (vista previa desde consecutivo)
        axios.get('/egresos/proximo-numero?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setNumeroEgreso(egresoDisplayFromResponse(response.data));
                }
            })
            .catch(error => console.log('err: ' + error));
    }, []);

    const agregarConcepto = () => {
        const concepto = conceptosPago.find(c => c.id == conceptoSeleccionado);
        if (concepto) {
            const nuevoProducto = {
                id: Date.now(),
                conceptos_pago_id: concepto.id,
                codigo: concepto.codigo,
                descripcion: concepto.nombre,
                cantidad: 1,
                precio: parseFloat(concepto.precio),
                descuento: 0,
                ajuste: 0,
                iva: 0,
                total: parseFloat(concepto.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setConceptoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                const subtotal = productoActualizado.precio * productoActualizado.cantidad;
                const descuentoTotal = subtotal * (productoActualizado.descuento / 100);
                const baseConDescuento = subtotal - descuentoTotal;
                const ivaTotal = baseConDescuento * (productoActualizado.iva / 100);
                productoActualizado.total = baseConDescuento + ivaTotal + productoActualizado.ajuste;
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let bruto = 0;
        let pagar = 0;
        productosArray.forEach(producto => {
            bruto += (producto.precio * producto.cantidad);
            pagar += producto.total;
        });
        setTotalBruto(bruto);
        setTotalPagar(pagar);
    };

    const getProveedoresFiltrados = () => {
        if (!busquedaProveedor) return proveedores;
        return proveedores.filter(proveedor => {
            const nombre = proveedor.nombre_proveedor || '';
            const documento = proveedor.numero_documento || '';
            const busqueda = busquedaProveedor.toLowerCase();
            return nombre.toLowerCase().includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getProveedoresPaginados = () => {
        const proveedoresFiltrados = getProveedoresFiltrados();
        const inicio = (paginaActual - 1) * proveedoresPorPagina;
        const fin = inicio + proveedoresPorPagina;
        return proveedoresFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getProveedoresFiltrados().length / proveedoresPorPagina);
    };

    const seleccionarProveedor = (proveedor) => {
        setProveedorId(proveedor.id);
        setNombreProveedor(proveedor.nombre_proveedor);
        setTipoProveedor(proveedor.tipo_documento || 'NIT');
        setDocumentoProveedor(proveedor.numero_documento || '');
        setShowModalProveedor(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!proveedorId) {
            setMensajeError('Por favor seleccione un proveedor');
            setShowModalError(true);
            return;
        }
        
        if (productos.length === 0) {
            setMensajeError('Debe agregar al menos un concepto de pago');
            setShowModalError(true);
            return;
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const egresoData = {
            uid: userdata.user_id,
            users_id: parseInt(usuario),
            proveedor_id: parseInt(proveedorId),
            fecha_creacion: fecha,
            forma_pago: metodoPago,
            valor_bruto: parseFloat(totalBruto),
            valor_total: parseFloat(totalPagar),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                conceptos_pago_id: parseInt(producto.conceptos_pago_id),
                cantidad: parseInt(producto.cantidad),
                vrunitario: parseFloat(producto.precio),
                descuento: parseFloat(producto.descuento),
                ajuste: parseFloat(producto.ajuste),
                iva: parseFloat(producto.iva)
            }))
        };

        try {
            const response = await axios.post('/egresos', egresoData);
            if (response.status === 200 || response.status === 201) {
                const numeroGuardado = egresoDisplayFromResponse(response.data);
                setEgresoGuardadoId(response.data.egreso_id || null);
                setNumeroEgresoCreado(numeroGuardado);
                setShowModalExito(true);
                
                // Limpiar formulario
                setProductos([]);
                setProveedorId('');
                setNombreProveedor('');
                setDocumentoProveedor('');
                setObservaciones('');
                setTotalBruto(0);
                setTotalPagar(0);
                
                // Próximo número solo para el formulario (no el modal de éxito)
                axios.get('/egresos/proximo-numero?uid=' + userdata.user_id)
                    .then(res => {
                        if (res.status === 200) {
                            setNumeroEgreso(egresoDisplayFromResponse(res.data));
                        }
                    });
            }
        } catch (error) {
            console.error('Error completo:', error);
            setMensajeError(getApiErrorMessage(error, 'Error al guardar el egreso.'));
            setShowModalError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleVolverListado = () => {
        setShowModalExito(false);
        history.push('/listado-egresos');
    };

    const handleCrearOtro = () => {
        setShowModalExito(false);
        setEgresoGuardadoId(null);
        setNumeroEgresoCreado('');
    };

    const handleVerEgreso = () => {
        if (egresoGuardadoId) {
            setShowModalExito(false);
            history.push(`/vista-previa-egreso/${egresoGuardadoId}`);
        }
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition egreso-page">
            <style>{`
                .egreso-page { font-size: 12.5px; }
                .egreso-page .content-header h1 {
                    font-size: 1.9rem !important;
                    font-weight: 800 !important;
                    margin-bottom: 0 !important;
                }
                .egreso-page label {
                    font-size: 0.76rem;
                    font-weight: 700;
                    color: #6c757d;
                    margin-bottom: 6px;
                    text-transform: uppercase;
                    letter-spacing: .03rem;
                }
                .egreso-page .form-control {
                    font-size: 0.82rem !important;
                    padding: 0.38rem 0.68rem !important;
                    min-height: 36px;
                }
                .egreso-page .btn { font-size: 0.82rem !important; }
                .egreso-soft-card {
                    border-radius: 16px !important;
                    border: 1px solid rgba(0,0,0,0.05) !important;
                    box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                }
                .egreso-soft-header {
                    background: #fff;
                    border-bottom: 1px solid rgba(0,0,0,0.06);
                }
                .egreso-main-title {
                    margin: 0;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 1rem;
                    font-weight: 800;
                    color: #323a45;
                }
                .egreso-main-title .title-icon {
                    width: 28px;
                    height: 28px;
                    border-radius: 9px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(23,162,184,0.1);
                    color: #17a2b8;
                    font-size: 0.85rem;
                }
                .egreso-section-title {
                    margin: 0 0 14px 0;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 0.95rem;
                    font-weight: 800;
                    color: #323a45;
                }
                .egreso-section-title .title-icon {
                    width: 26px;
                    height: 26px;
                    border-radius: 8px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(50,58,69,0.08);
                    color: #323a45;
                    font-size: 0.78rem;
                }
                .egreso-modal .modal-content {
                    border-radius: 16px !important;
                    border: 1px solid rgba(0,0,0,0.08) !important;
                    box-shadow: 0 12px 32px rgba(0,0,0,0.08) !important;
                    overflow: hidden;
                }
                .egreso-modal .modal-header.egreso-modal-head-neutral {
                    background: #f8f9fa !important;
                    border-bottom: 1px solid rgba(0,0,0,0.06) !important;
                }
                .egreso-modal .modal-header.egreso-modal-head-error {
                    background: #f8f9fa !important;
                    border-bottom: 3px solid #dc3545 !important;
                }
                .factura-lineas-table .factura-col-accion-head,
                .factura-lineas-table .factura-col-accion-body {
                    width: 44px;
                    min-width: 44px;
                    max-width: 44px;
                    padding: 6px 4px !important;
                    text-align: center;
                    vertical-align: middle !important;
                    white-space: nowrap;
                }
                .factura-lineas-table {
                    table-layout: fixed;
                    border-collapse: collapse;
                }
                .factura-lineas-table th,
                .factura-lineas-table td {
                    border: none !important;
                }
                .factura-lineas-table thead th {
                    border-bottom: 1px solid #dee2e6 !important;
                    padding-bottom: 8px;
                    font-size: 0.75rem;
                    font-weight: 600;
                    color: #6c757d;
                }
                .factura-lineas-table tfoot tr:first-child td {
                    border-top: 1px solid #e9ecef !important;
                    padding-top: 10px;
                }
                .factura-lineas-table .factura-col-descripcion {
                    text-align: center;
                    vertical-align: middle;
                    font-size: 0.875rem;
                    padding: 8px 10px;
                    line-height: 1.35;
                    word-break: break-word;
                }
                .factura-lineas-table .factura-col-cant,
                .factura-lineas-table .factura-col-desc {
                    width: 72px;
                    max-width: 72px;
                }
                .factura-lineas-table .factura-col-precio {
                    width: 118px;
                    max-width: 118px;
                }
                .factura-lineas-table .factura-input-cant,
                .factura-lineas-table .factura-input-desc {
                    width: 100% !important;
                    max-width: 64px !important;
                    min-width: 0 !important;
                    min-height: 32px !important;
                    padding: 0.28rem 0.35rem !important;
                    margin: 0 auto;
                    text-align: center;
                    -moz-appearance: textfield;
                }
                .factura-lineas-table .factura-input-precio,
                .factura-lineas-table .factura-input-ajuste {
                    width: 100% !important;
                    max-width: 110px !important;
                    min-height: 32px !important;
                    padding: 0.28rem 0.4rem !important;
                    text-align: right;
                    -moz-appearance: textfield;
                }
                .factura-lineas-table .factura-input-cant::-webkit-outer-spin-button,
                .factura-lineas-table .factura-input-cant::-webkit-inner-spin-button,
                .factura-lineas-table .factura-input-desc::-webkit-outer-spin-button,
                .factura-lineas-table .factura-input-desc::-webkit-inner-spin-button,
                .factura-lineas-table .factura-input-precio::-webkit-outer-spin-button,
                .factura-lineas-table .factura-input-precio::-webkit-inner-spin-button,
                .factura-lineas-table .factura-input-ajuste::-webkit-outer-spin-button,
                .factura-lineas-table .factura-input-ajuste::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
                .factura-lineas-table tfoot .factura-total-label-cell {
                    border: none !important;
                    text-align: right;
                    vertical-align: middle !important;
                    padding: 3px 10px 3px 4px !important;
                    font-size: 0.8rem;
                    font-weight: 400;
                    color: #6c757d;
                    white-space: nowrap;
                    min-width: 118px;
                    line-height: 1.25;
                    overflow: visible;
                }
                .factura-lineas-table tfoot .factura-total-value-cell {
                    border: none !important;
                    padding: 3px 4px 3px 0 !important;
                    vertical-align: middle !important;
                    width: 14%;
                    min-width: 120px;
                }
                .factura-total-value-input {
                    width: 100%;
                    max-width: 100%;
                    text-align: right;
                    font-size: 0.85rem;
                    font-weight: 400;
                    color: #495057;
                    background-color: #f8f9fa !important;
                    padding: 0.28rem 0.4rem !important;
                    min-height: 30px !important;
                }
                .factura-total-value-input.factura-total-final {
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #17a2b8;
                }
            `}</style>
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item">Crear Egreso</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Crear Egreso</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-info card-outline egreso-soft-card">
                            <div className="card-header egreso-soft-header">
                                <h5 className="egreso-main-title">
                                    <span className="title-icon"><i className="fas fa-money-bill-wave"></i></span>
                                    Información del Egreso
                                </h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    
                                    <h5 className="egreso-section-title">
                                        <span className="title-icon"><i className="fas fa-truck"></i></span>
                                        Información del Proveedor
                                    </h5>
                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Nombre *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={nombreProveedor}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Tipo *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={tipoProveedor}
                                                    disabled
                                                    required
                                                >
                                                    <option value="NIT">NIT</option>
                                                    <option value="CC">CC</option>
                                                    <option value="CE">CE</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>N° Documento *</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={documentoProveedor}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info form-control"
                                                    onClick={() => setShowModalProveedor(true)}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5 className="egreso-section-title">
                                        <span className="title-icon"><i className="fas fa-calendar-alt"></i></span>
                                        Datos del Egreso
                                    </h5>

                                    <div className="row egreso-datos-row">
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Fecha *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control form-control-sm" 
                                                    value={fecha}
                                                    onChange={(e) => setFecha(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>Usuario *</label>
                                                <select 
                                                    className="form-control form-control-sm" 
                                                    value={usuario}
                                                    onChange={(e) => setUsuario(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {usuarios.map(u => (
                                                        <option key={u.id} value={u.id}>{u.name} {u.lastname}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>N° Egreso</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control form-control-sm" 
                                                    value={numeroEgreso}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>Método de Pago *</label>
                                                <select 
                                                    className="form-control form-control-sm" 
                                                    value={metodoPago}
                                                    onChange={(e) => setMetodoPago(e.target.value)}
                                                    required
                                                >
                                                    {FORMA_PAGO_OPCIONES.map((op) => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5 className="egreso-section-title">
                                        <span className="title-icon"><i className="fas fa-list-ul"></i></span>
                                        Conceptos de Pago
                                    </h5>

                                    <div className="row">
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label>Selecciona el Concepto</label>
                                                <select 
                                                    className="form-control" 
                                                    value={conceptoSeleccionado}
                                                    onChange={(e) => setConceptoSeleccionado(e.target.value)}
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {conceptosPago.map(concepto => (
                                                        <option key={concepto.id} value={concepto.id}>
                                                            {concepto.codigo} - {concepto.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-info form-control"
                                                    onClick={agregarConcepto}
                                                >
                                                    Agregar
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                        <table className="table factura-lineas-table" style={{ minWidth: '960px' }}>
                                            <thead>
                                                <tr>
                                                    <th className="text-center" style={{ width: '10%', minWidth: '88px' }}>Código</th>
                                                    <th className="text-center factura-col-descripcion">Descripción</th>
                                                    <th className="text-center factura-col-cant">Cant.</th>
                                                    <th className="text-center factura-col-precio">Precio</th>
                                                    <th className="text-center factura-col-desc">Desc %</th>
                                                    <th className="text-center" style={{ width: '9%', minWidth: '88px' }}>Ajuste</th>
                                                    <th className="text-center" style={{ width: '7%', minWidth: '72px' }}>IVA %</th>
                                                    <th className="text-center" style={{ width: '14%', minWidth: '120px' }}>Total</th>
                                                    <th className="text-center factura-col-accion-head"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productos.map(producto => (
                                                    <tr key={producto.id}>
                                                        <td className="text-center">{producto.codigo}</td>
                                                        <td className="factura-col-descripcion">{producto.descripcion}</td>
                                                        <td className="text-center factura-col-cant">
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm factura-input-cant" 
                                                                value={producto.cantidad}
                                                                onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                min="1"
                                                            />
                                                        </td>
                                                        <td className="text-right factura-col-precio">
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm factura-input-precio" 
                                                                value={producto.precio}
                                                                onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td className="text-center factura-col-desc">
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm factura-input-desc" 
                                                                value={producto.descuento}
                                                                onChange={(e) => actualizarProducto(producto.id, 'descuento', e.target.value)}
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm factura-input-ajuste" 
                                                                value={producto.ajuste}
                                                                onChange={(e) => actualizarProducto(producto.id, 'ajuste', e.target.value)}
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <input 
                                                                type="number" 
                                                                className="form-control form-control-sm factura-input-desc" 
                                                                value={producto.iva}
                                                                onChange={(e) => actualizarProducto(producto.id, 'iva', e.target.value)}
                                                                min="0"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            $ {parseFloat(producto.total || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td className="factura-col-accion-body">
                                                            <button 
                                                                type="button" 
                                                                className="btn p-0 border-0 bg-transparent text-danger"
                                                                onClick={() => eliminarProducto(producto.id)}
                                                                title="Eliminar concepto"
                                                            >
                                                                <i className="fas fa-trash-alt"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                                    <td colSpan="2" className="factura-total-label-cell">Total bruto:</td>
                                                    <td className="factura-total-value-cell">
                                                        <input 
                                                            type="text" 
                                                            className="form-control form-control-sm factura-total-value-input" 
                                                            value={'$ ' + parseFloat(totalBruto || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td style={{ border: 'none' }}></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="5" style={{ border: 'none' }}></td>
                                                    <td colSpan="2" className="factura-total-label-cell">Total a pagar:</td>
                                                    <td className="factura-total-value-cell">
                                                        <input 
                                                            type="text" 
                                                            className="form-control form-control-sm factura-total-value-input factura-total-final" 
                                                            value={'$ ' + parseFloat(totalPagar || 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td style={{ border: 'none' }}></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <hr />

                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={observaciones}
                                            onChange={(e) => setObservaciones(e.target.value)}
                                            placeholder="Observaciones del egreso..."
                                        ></textarea>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-info mr-2" disabled={loading}>
                                            <i className="fas fa-save"></i> Guardar Egreso
                                            {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                        </button>
                                        <Link to="/listado-egresos" className="btn btn-secondary">
                                            <i className="fas fa-arrow-left"></i> Cancelar
                                        </Link>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Seleccionar Proveedor */}
            {showModalProveedor && (
                <div className="modal fade show egreso-modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.45)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header egreso-modal-head-neutral">
                                <h5 className="modal-title text-dark font-weight-bold mb-0">
                                    <i className="fas fa-truck mr-2 text-info"></i>
                                    Seleccionar Proveedor
                                </h5>
                                <button type="button" className="close" onClick={() => setShowModalProveedor(false)} aria-label="Cerrar">
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Buscar por nombre o documento..."
                                        value={busquedaProveedor}
                                        onChange={(e) => {
                                            setBusquedaProveedor(e.target.value);
                                            setPaginaActual(1);
                                        }}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Documento</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getProveedoresPaginados().map((proveedor, index) => (
                                                <tr key={index}>
                                                    <td>{proveedor.nombre_proveedor}</td>
                                                    <td>{proveedor.numero_documento}</td>
                                                    <td>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarProveedor(proveedor)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {getTotalPaginas() > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === 1}
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                        >
                                            Anterior
                                        </button>
                                        <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            disabled={paginaActual === getTotalPaginas()}
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer border-top bg-light">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalProveedor(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Éxito */}
            <Modal
                show={showModalExito}
                onHide={() => setShowModalExito(false)}
                centered
                dialogClassName="egreso-modal"
                contentClassName="border-0"
            >
                <Modal.Header closeButton className="egreso-modal-head-neutral border-bottom">
                    <Modal.Title className="h6 text-dark font-weight-bold mb-0">
                        <i className="fas fa-check-circle mr-2 text-info"></i>
                        Egreso guardado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-4">
                        <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                            style={{
                                width: 72,
                                height: 72,
                                background: 'rgba(23, 162, 184, 0.12)',
                                color: '#17a2b8'
                            }}
                        >
                            <i className="fas fa-money-bill-wave" style={{ fontSize: '2rem' }}></i>
                        </span>
                    </div>
                    <h5 className="mb-3 text-dark" style={{ fontWeight: 700 }}>El egreso se registró correctamente</h5>
                    <p className="text-muted mb-0">
                        N° Egreso: <strong className="text-dark">{numeroEgresoCreado}</strong>
                    </p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center flex-wrap border-top bg-light">
                    <Button variant="secondary" onClick={handleVolverListado}>
                        <i className="fas fa-list mr-2"></i>
                        Volver al Listado
                    </Button>
                    {egresoGuardadoId && (
                        <Button variant="info" onClick={handleVerEgreso}>
                            <i className="fas fa-eye mr-2"></i>
                            Ver Egreso
                        </Button>
                    )}
                    <Button variant="primary" onClick={handleCrearOtro}>
                        <i className="fas fa-plus mr-2"></i>
                        Crear Otro Egreso
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Error */}
            <Modal
                show={showModalError}
                onHide={() => setShowModalError(false)}
                centered
                dialogClassName="egreso-modal"
                contentClassName="border-0"
            >
                <Modal.Header closeButton className="egreso-modal-head-error">
                    <Modal.Title className="h6 text-dark font-weight-bold mb-0">
                        <i className="fas fa-exclamation-triangle mr-2 text-danger"></i>
                        No se pudo guardar
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-4">
                        <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle"
                            style={{
                                width: 72,
                                height: 72,
                                background: 'rgba(220, 53, 69, 0.1)',
                                color: '#dc3545'
                            }}
                        >
                            <i className="fas fa-times" style={{ fontSize: '2rem' }}></i>
                        </span>
                    </div>
                    <h5 className="mb-3 text-dark" style={{ fontWeight: 600 }}>Revise los datos e intente de nuevo</h5>
                    <p className="text-muted mb-0 text-left" style={{ maxWidth: 420, margin: '0 auto' }}>{mensajeError}</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-top bg-light">
                    <Button variant="primary" onClick={() => setShowModalError(false)}>
                        <i className="fas fa-times mr-2"></i>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default CrearEgreso;